var _path, _path2, _path3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHeart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 104,
    height: 72,
    viewBox: "0 0 104 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M94.1428 28.2858C96.5017 58.4466 71.9294 72.0001 52.5559 72.0001C33.1825 72.0001 8 55.7096 8 38.3592C8 21.0087 12.6244 10.2044 32.1126 3.51403C51.6008 -3.17638 91.784 -1.87496 94.1428 28.2858Z",
    fill: "#F7F7FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M61.349 19.3655C56.4904 19.3655 53.8272 22.3819 51.7147 24.4737C49.6021 22.3819 46.939 19.3655 42.0804 19.3655C37.2218 19.3655 32.1962 23.9498 32.4465 30.4988C32.4465 39.7984 45.045 47.9846 51.7147 52.6345C58.3844 47.9846 70.9829 39.7984 70.9829 30.4988C71.2331 23.9498 66.2076 19.3655 61.349 19.3655Z",
    fill: "url(#paint0_radial_21155_25621)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2759 7.24C10.0039 7.336 9.51591 7.464 8.81191 7.624C8.10791 7.768 7.55591 7.864 7.15591 7.912L6.89191 6.232C7.75591 6.056 8.65191 5.744 9.57991 5.296C10.5239 4.832 11.2919 4.352 11.8839 3.856H11.9079L13.8039 4.12V17.32L16.5399 17.584V19H7.39591V17.584L10.2759 17.344V7.24Z",
    fill: "#8E8CEE"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_21155_25621",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(67.3211 19.3655) rotate(127.736) scale(42.0681 50.4542)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CDCCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.330493,
    stopColor: "#CAC9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.333117,
    stopColor: "#BAB9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.630108,
    stopColor: "#BBB9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.630208,
    stopColor: "#9E9CFE"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/heart.89821f2902b998a9b692bf064e1c0871.svg";
export { ForwardRef as ReactComponent };